exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-control{background-color:#fff;margin:5px}.button-control>button{height:24px;background:#fff none repeat scroll 0 0 padding-box;padding:3px 4px 4px}.control-left{font-size:20px}.modal{display:flex;height:auto}.btn-close{position:absolute;top:0;right:0;border:none;font-size:20px;padding:10px;cursor:pointer;font-weight:700;color:#4aae9b;background:transparent}.btn-green{color:#fff;background:#4aae9b;border:1px solid #4aae9b;border-radius:2px}", ""]);

// exports
